import { render, staticRenderFns } from "./OpenVPNServerShow.vue?vue&type=template&id=94608416&"
import script from "./OpenVPNServerShow.vue?vue&type=script&lang=js&"
export * from "./OpenVPNServerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports